export default class BoardEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#board_uuid") ? (elem.querySelector("#board_uuid") as HTMLInputElement).value : null,
            name: (elem.querySelector("#board_name") as HTMLInputElement).value,
            // @ts-ignore
            customers: elem.querySelector("#board_customers_new") ? Array.from(elem.querySelectorAll("#board_customers_new option:checked")).map((o: HTMLInputElement) => {
                return o.value
            }) : Array.from(elem.querySelectorAll("#board_customers option:checked")).map((o: HTMLInputElement) => {
                return o.value
            })
        }
    }
}